// Helpers para push notifications no cliente.
// Exige Service Worker registrado em /sw.js.

import api from './api';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) out[i] = raw.charCodeAt(i);
  return out;
}

export function pushSuportado() {
  return (
    typeof window !== 'undefined' &&
    'serviceWorker' in navigator &&
    'PushManager' in window &&
    'Notification' in window
  );
}

export function statusPermissao() {
  if (!('Notification' in window)) return 'unsupported';
  return Notification.permission; // 'default' | 'granted' | 'denied'
}

export async function subscriptionAtual() {
  const reg = await navigator.serviceWorker.ready;
  return reg.pushManager.getSubscription();
}

export async function ativarPush() {
  if (!pushSuportado()) throw new Error('Push não suportado neste navegador');

  const permissao = await Notification.requestPermission();
  if (permissao !== 'granted') {
    throw new Error(
      permissao === 'denied'
        ? 'Você bloqueou notificações. Reabilite nas configurações do navegador.'
        : 'Permissão não concedida.'
    );
  }

  const { data } = await api.get('/push/vapid-key');
  if (!data?.publicKey) throw new Error('Servidor não configurou push (sem chave VAPID).');

  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.publicKey)
    });
  }

  await api.post('/push/subscribe', { subscription: sub.toJSON() });
  return sub;
}

export async function desativarPush() {
  const sub = await subscriptionAtual();
  if (!sub) return;
  try { await api.delete('/push/unsubscribe', { data: { endpoint: sub.endpoint } }); } catch {}
  await sub.unsubscribe();
}

export async function enviarTeste() {
  await api.post('/push/test');
}
